<template>
  <div class="wg-row wg-xs-12">
    <div class="wg-col wg-xs-12 wg-lg-7">
      <h1
        class="com-anm22-page-title"
      >{{ $anm22.strLang(lang, 'Project developers', 'Aziende sviluppatrici') }}</h1>
      <template v-if="!offline">
        <div
          class="com-anm22-app-text-l"
        >{{ $anm22.strLang(lang, 'Type to add new developers', 'Digita per aggiungere un\'azienda') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- search bar with list -->
        <wg-search
          :placeholder="$anm22.strLang(lang, 'Company', 'Azienda')"
          :url="'work/getByName'"
          :clickFn="addDeveloper"
          :debounceTime="2000"
        ></wg-search>
      </template>
      <!-- List of developers -->
      <div class="vertical-height-div" style="height:20px;"></div>
      <div class="wg-row">
        <div
          class="wg-row"
          style="align-items:center;"
          v-for="(dev, index) in developers"
          :key="'dev-' + index"
        >
          <!-- <img
            :src="$anm22.getObjIcon(dev, 'workDefault')"
            :title="dev.name"
            class="com-anm22-app-img-fixed-height-l com-anm22-round"
            style="margin-right:5px;"
          > -->
          <div style="min-width:30px;width:30px;height:30px;margin-right:5px;">
            <world-object-icon
                :type="'work'" 
                :obj="dev"
                :isImg="true">
            </world-object-icon>
          </div>
          <div>
            <div class="com-anm22-app-text-m" style="font-weight:bold;">{{ dev.name }}</div>
            <div class="vertical-height-div" style="height:2px;"></div>
            <div
              v-if="!offline && developers.length > 1"
              class="display-flex"
              style="align-items:center;cursor:pointer;"
              @click="removeDeveloper(dev.idWorldWork)"
            >
              <img
                class="com-anm22-app-img-fixed-height-s"
                :src="$anm22.icons.getWorldIcon('deleteRed')"
              >
              <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </div>
      </div>
    </div>
    <div class="wg-col wg-xs-none wg-lg-5 project-manage-help-box">
      <img :src="$anm22.icons.getWorldIcon('workMaterial')" />
      <div>
        <strong>{{$anm22.strLang(lang, 'Set project companies', 'Imposta le aziende del progetto')}}</strong><br />
        {{$anm22.strLang(lang, '', "Imposta le aziende che contribuiscono al progetto. Inserendo un'altra compagnia, questa avrà accesso al progetto e potrà aggiornarlo.")}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    data: Object
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user,
      offline: state => state.offline.isOffline
    }),
    project() {
      return this.$store.getters["projects/get"](
        this.data.project.idWorldProject
      );
    },
    developers() {
      return this.project.developers.map(d => this.$store.getters["works/get"](d)).filter(w => w);
    }
  },
  methods: {
    addDeveloper(id) {
      this.$http
        .post("/project/addDeveloper", {
          projectId: this.project.idWorldProject,
          developerId: id
        })
        .then(response => {
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("works/update", {
              vlf: this.$vlf("works"),
              objs: [response.data.developer]
            })
          ]);
        })
        .catch(error => {});
    },
    removeDeveloper(workId) {
      this.$http
        .post("/project/removeDeveloper", {
          projectId: this.project.idWorldProject,
          developerId: workId
        })
        .then(response => {
          return Promise.all([
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            }),
            this.$store.dispatch("works/delete", {
              vlf: this.$vlf("works"),
              obj: workId
            })
          ]);
        })
        .catch(error => {});
    }
  },
  created() {
    this.$http
      .get("project/developers?idProject=" + this.$route.params.id)
      .then(response => {
        this.$store
          .dispatch("works/update", {
            vlf: this.$vlf("works"),
            objs: response.data.works
          })
          .then(() => {
            this.$Progress.finish();
          })
          .catch(error => {
            console.log(error);
          });
      })
      .catch(error => {
        this.$store
          .dispatch("works/load", this.$vlf("works"))
          .then(() => {
            this.$Progress.finish();
          })
          .catch(error => {
            console.log(error);
          });
      });
  }
};
</script>

<style lang="scss" scoped>
</style>
